<template>
  <div :class="getClass">
    <img
      :src="imageUrl ? getUrl : ''"
      alt=""
      @error="checkImage"
    />
    <div class="hover-icon">
      <i
        class="el-icon-zoom-in"
        @click="handleShow"
      />
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :lock-scroll="false"
    >
      <img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
  </div>
</template>

<script>
import baseUrl from "../api/baseUrl";
import { buildClass } from "../utils/myUtils";
export default {
  props: {
    imageUrl: String,
  },
  data () {
    return {
      baseUrl,
      dialogVisible: false,
      dialogImageUrl: "",
      isHover: true,
    }
  },
  computed: {
    getUrl () {
      return this.baseUrl + this.imageUrl;
    },
    getClass () {
      return buildClass({
        "showImage": true,
        "showHover": this.getUrl && this.isHover,
      })
    }
  },
  methods: {
    handleShow () {
      this.dialogVisible = true;
      this.dialogImageUrl = this.getUrl;
    },
    // 判断图片是否存在, 404
    checkImage () {
      this.isHover = false;
    }
  }
}
</script>

<style lang="less" scoped>
.showImage {
  width: 100%;
  height: 100%;
  border: 1px solid #d4d4d7;
  position: relative;
  display: flex;
  background: #fafafa;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .hover-icon {
    position: absolute;
    width: 100%;
    height: 100%;
    font-size: 40px;
    display: none;
  }
}
.showHover {
  &:hover {
    .hover-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: white;
      cursor: pointer;
      background: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
